import { styled } from "@mui/material";

export const TimelineWrapper = styled("div")(({ theme }) => ({
  flexGrow: 1,
  flexDirection: "column",
  display: "flex",

  "&>:nth-child(n + 2)": {
    marginTop: theme.spacing(2),
  },
}));
